import { NavLink } from "react-router-dom";
import {
    logo,
	logo_MetaMask
} from '../../utils/allImgs'
import data from '../../data/data-layouts/data-Head.json'

function Head(){

  return(
    <div className="header header-fixed">
        <div className="navbar">
            <div className="logo">
                <a href="/#"><img loading="lazy" data-src={logo} alt="Rocket logo" className="logo" /></a>
            </div>
            <input type="checkbox" id="navbar-toggle" />
            <label htmlFor="navbar-toggle"><i /></label>
            <nav className="menu">
                <ul>
                    {data && data[0].menuLinks.map((item , key) => (
                        <li key={key}><NavLink to={item.path}>{item.title}</NavLink></li>
                    ))}
                    <button className="connect__btn">
                        {data[0].connect__btn}
                        <img loading="lazy" data-src={logo_MetaMask} alt="MetaMask Logo" className="connect__icon" />
                    </button>
                </ul>
            </nav>        
        </div>
    </div>
  )
}

export default Head